export default __webpack_public_path__ + "assets/images/16d9fb8602d8e675ba685f334d62d2c1.svg";